import { fetch } from '../utils/fetch'

/*
    API:    POST
    NAME:   获取支付二维码信息
*/
export function getPayQrCode(id) {
  return fetch({
    url: `sms/order/${id}`,
    method: 'get'
  })
}

/*
    API:    POST
    NAME:   获取短信套餐信息
*/
export function getPayList() {
  return fetch({
    url: `sms/config`,
    method: 'get'
  })
}

/*
    API:    GET
    NAME:   获取短信消耗列表
*/
export function getSmsList(data) {
  return fetch({
    url: `sms/queryList`,
    method: 'get',
    params: data
  })
}

/*
    API:    POST
    NAME:   获取支付二维码信息
*/
export function getMarketPayQrCode(id) {
  return fetch({
    url: `market/order/${id}`,
    method: 'get'
  })
}

/*
    API:    POST
    NAME:   获取套餐信息
*/
export function getMarketPayList(data) {
  return fetch({
    url: `/market/queryProductByType`,
    method: 'get',
    params: data
  })
}

/*
    API:    POST
    NAME:   获取套餐剩余
*/
export function getMarketRelease(data) {
  return fetch({
    url: `/market/querySiteRelease`,
    method: 'get',
    params: data
  })
}
